<template>
  <div class="row">
    <GenericProps
      :node-id="node.id"
      :settings.sync="settings"
      :parameters="node.parameters"
      @update:settings="updateNodeParent"
    />
  </div>
</template>

<script>

import { merge } from 'lodash';
import {
  getFieldError,
  getFieldSize,
  createSettingsHierarchy
} from '../../../helpers/node';
import nodePropsMixin from '@/modules/ivrs/mixins/nodePropsMixin';

export default {
  name: 'GenericNodeProps',

  mixins: [nodePropsMixin],

  watch: {
    node() {
      this.buildNodeSettings();
    },
  },
  created() {
    this.buildNodeSettings();
  },
  methods: {
    getFieldError,
    
    getFieldSize,

    buildNodeSettings() {
      // Sets value of settings data
      this.settings = createSettingsHierarchy(this.node, undefined, undefined, this.node.settings);

      // Merges built settings hierarchy with current node settings
      this.settings = merge(this.settings.root, this.node.settings);
    }
  }
};
</script>

<style>
</style>